/**
 * 词典聚合：四语言全量同步打包（营销站体量小，刻意不用 http-backend 懒加载）。
 * namespace 划分见仓库 CLAUDE.md「i18n 双语体系」。
 * ko/ru 于 2026-09-17 起补齐全部 8 个命名空间（about/docs/faq/languages/legal
 * 为当日 AI 翻译上线，法律类文案待业务方校对）——四语页面不再回退中文；
 * 壳模式长文页（政策/文档）经各自 index.tsx 按 i18n.language 选内容组件。
 */
import aboutEn from './resources/en/about.json';
import commonEn from './resources/en/common.json';
import docsEn from './resources/en/docs.json';
import faqEn from './resources/en/faq.json';
import homeEn from './resources/en/home.json';
import languagesEn from './resources/en/languages.json';
import legalEn from './resources/en/legal.json';
import productsEn from './resources/en/products.json';
import aboutKo from './resources/ko/about.json';
import commonKo from './resources/ko/common.json';
import docsKo from './resources/ko/docs.json';
import faqKo from './resources/ko/faq.json';
import homeKo from './resources/ko/home.json';
import languagesKo from './resources/ko/languages.json';
import legalKo from './resources/ko/legal.json';
import productsKo from './resources/ko/products.json';
import aboutRu from './resources/ru/about.json';
import commonRu from './resources/ru/common.json';
import docsRu from './resources/ru/docs.json';
import faqRu from './resources/ru/faq.json';
import homeRu from './resources/ru/home.json';
import languagesRu from './resources/ru/languages.json';
import legalRu from './resources/ru/legal.json';
import productsRu from './resources/ru/products.json';
import aboutZh from './resources/zh-CN/about.json';
import commonZh from './resources/zh-CN/common.json';
import docsZh from './resources/zh-CN/docs.json';
import faqZh from './resources/zh-CN/faq.json';
import homeZh from './resources/zh-CN/home.json';
import languagesZh from './resources/zh-CN/languages.json';
import legalZh from './resources/zh-CN/legal.json';
import productsZh from './resources/zh-CN/products.json';

const resources = {
  en: {
    about: aboutEn,
    common: commonEn,
    docs: docsEn,
    faq: faqEn,
    home: homeEn,
    languages: languagesEn,
    legal: legalEn,
    products: productsEn,
  },
  ko: {
    about: aboutKo,
    common: commonKo,
    docs: docsKo,
    faq: faqKo,
    home: homeKo,
    languages: languagesKo,
    legal: legalKo,
    products: productsKo,
  },
  ru: {
    about: aboutRu,
    common: commonRu,
    docs: docsRu,
    faq: faqRu,
    home: homeRu,
    languages: languagesRu,
    legal: legalRu,
    products: productsRu,
  },
  'zh-CN': {
    about: aboutZh,
    common: commonZh,
    docs: docsZh,
    faq: faqZh,
    home: homeZh,
    languages: languagesZh,
    legal: legalZh,
    products: productsZh,
  },
};

export default resources;
